export interface Phase {
	id: number;
	remark?: string;
}

export enum DB_PHASES {
	P0 = 1,
	P1 = 2,
	P2 = 3,
	P3 = 4,
	P4 = 5,
	FP3 = 6,
	FP4 = 7,
	FP5 = 8,
}

/**
 * Why are there gaps in the numbering? And why do they look like random?
 * They are not random. The first digit represent the from phase, the second digit the to phase.
 * This makes transition phase calculations based on set phase id on assignment and phaseChangeID easier.
 * E.g. an assignment in phase 1 (assignment.phaseId = 2) that wants to move to phase 2 (phaseChangeId = 3) will have the type 23 (1 to 2).
 */
export enum PHASE_TRANSITION_TYPES {
	UNKNOWN = 0,
	P0_TO_P4 = 15,
	P1_TO_P4 = 25,
	P2_TO_P4 = 35,
	P3_TO_P4 = 45,
	P2_TO_P3 = 34,
	P1_TO_P2 = 23,
	P1_TO_P3 = 24,
}
